import TOGGLE from './mutations';

export default {
  namespaced: true,
  state() {
    return {
      expanded: {},
    };
  },
  mutations: {
    [TOGGLE](state, id) {
      if (!state.expanded[id]) {
        state.expanded = {};
      }
      state.expanded[id] = !state.expanded[id];
    },
  },
};
